import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Modal, Button } from "antd";

class ModalCfop extends Component {
  state = { id: null };

  componentDidMount() {
    const { id } = this.props.match.params;

    this.setState({ id: id });
  }

  render() {
    const {
      type,
      modalKey,
      title,
      caption,
      okText,
      removeCancel,
      visible,
      closeModal,
      action,
      isFetching
    } = this.props;
    const { id } = this.state;

    return (
      <Modal
        className={`ant-modal--cfop ${
          type === "danger" ? "ant-modal--danger" : ""
        }`}
        title={title}
        visible={visible}
        closable={false}
        footer={[
          <Button
            className={removeCancel ? "d-none" : ""}
            key="back"
            onClick={() => closeModal(modalKey)}
          >
            Cancelar
          </Button>,
          <Button
            key="submit"
            type={type}
            loading={isFetching ? true : false}
            onClick={() => {
              closeModal(modalKey);
              action(id);
            }}
          >
            {okText}
          </Button>
        ]}
      >
        <p>{caption}</p>
      </Modal>
    );
  }
}

export default withRouter(ModalCfop);
